<div class="edit-modal-layout {{layoutClass}}">
  <div class="edit-modal-layout__container">
    <h2 class="edit-modal-layout__title">
      {{pageTitle | async}}
    </h2>

    <mat-card>
      <mat-card-content>
        <ng-content></ng-content>
      </mat-card-content>
    </mat-card>
    @if (showRequiredText) {
      <div><b>"*"</b> - <span class="required-text">{{'Required Field' | translate}} </span></div>
    }

    <div class="edit-modal-layout__actions">
      @if (showSave) {
        <button [disabled]="!saveEnabled"
          (click)="onSaveClicked($event)"
          mat-mini-fab
          [id]="saveId"
          color="primary"
          type="button"
          >
          <mat-icon>save</mat-icon>
        </button>
      }

      <button (click)="onCancel.emit()"
        mat-mini-fab
        [id]="cancelId"
        color="warn"
        type="button">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>
